import { z } from 'zod';
import { ErrorCode } from '../error-codes.js';
const HostCapabilities = z.object({
    capture: z.string(),
    input: z.string(),
    codecs: z.array(z.string()).min(1),
});
const ClientCapabilities = z.object({
    codecs: z.array(z.string()).min(1),
});
export const HostHello = z.object({
    hostToken: z.string().min(1),
    hostName: z.string().min(1),
    agentVersion: z.string().min(1),
    capabilities: HostCapabilities,
});
export const HostHelloAck = z.object({
    hostId: z.string().min(1),
    heartbeatIntervalSec: z.number().int().positive(),
});
export const ClientHello = z.object({
    sessionJwt: z.string().min(1),
    sessionId: z.number().int().positive(),
    deviceToken: z.string().nullable(),
    clientVersion: z.string().min(1),
    capabilities: ClientCapabilities,
});
export const ClientHelloAck = z.object({
    userId: z.string().min(1),
});
export const AuthError = z.object({
    code: z.enum([
        ErrorCode.AUTH_REQUIRED,
        ErrorCode.AUTH_INVALID,
        ErrorCode.AUTH_EXPIRED,
        ErrorCode.PROTOCOL_VERSION_MISMATCH,
    ]),
    message: z.string(),
});
//# sourceMappingURL=auth.js.map